import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { uamApi } from "@/api/uamApi";
import { REM_CONFIG } from "@/utils/fontSize";
const AssetReuseStatus = ({ className = "", }) => {
    const chartRef = useRef(null);
    const [selectedTime, setSelectedTime] = useState("2025-09"); // 示例时间，可根据业务调整
    const [chartData, setChartData] = useState([]);
    const subSystemLabels = chartData.map((item) => item.usingStatusName) || [];
    const assetNum = chartData.map((item) => item.assetNum) || [];
    const assetValue = chartData.map((item) => item.assetValue) || [];
    // 初始化表格数据（本地测试数据）
    useEffect(() => {
        getData();
    }, []);
    /**
     * @description: getData - 获取数据
     */
    const getData = async () => {
        try {
            const res = await uamApi.byStatus();
            setChartData(res.data);
        }
        catch (error) {
            // 可以设置默认数据或错误处理
        }
    };
    // 图表配置项（核心调整：双Y轴、图例、分类、渐变颜色）
    const getChartOption = () => ({
        title: {
            show: false,
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: { color: "#fff" },
        },
        grid: {
            left: "4%",
            right: "4%",
            bottom: "4%",
            top: 40,
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: subSystemLabels, // 替换原分类
            axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } },
        },
        yAxis: [
            {
                type: "value",
                name: "数量（项）", // 左侧Y轴：金额s
                axisLabel: {
                    color: "#fff",
                    fontSize: REM_CONFIG.fontSize.small,
                    interval: 0,
                },
                nameTextStyle: {
                    color: "#ffffff",
                    fontSize: REM_CONFIG.fontSize.small,
                },
                axisLine: { lineStyle: { color: "rgba(255,255,255,0.2)" } },
                splitLine: {
                    lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" }, // 网格线浅灰透明
                },
                position: "left",
            },
        ],
        series: [
            {
                name: "数量（项）",
                type: "bar",
                data: assetNum,
                yAxisIndex: 0, // 关联左侧金额轴
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#2F96E2" }, // 上半部分颜色
                        { offset: 1, color: "#1572C4" }, // 下半部分颜色（深蓝色渐变）
                    ]),
                    barBorderRadius: [8, 8, 0, 0],
                },
                barWidth: "15%",
            },
        ],
    });
    return (_jsxs("div", { className: `
        relative
        bg-gradient-to-t
        from-[rgba(7,31,75,0.5)]
        to-[rgba(6,32,66,0.5)]
        backdrop-blur-sm
        flex flex-col
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u5229\u65E7\u72B6\u51B5\u603B\u91CF\u7EDF\u8BA1" }), " ", _jsx("div", { className: "flex-1", style: { minHeight: 0 }, children: _jsx(ReactEcharts, { ref: chartRef, option: getChartOption(), style: { width: "100%", height: "100%" }, echarts: echarts }) })] }));
};
export default AssetReuseStatus;
